import Layout from './Layout'
import Hotel from './Hotel'
import RoomListItem from './RoomListItem'
import Documentation from './Documentation'
import SingleRoom from './SingleRoom'
import DoubleRoom from './DoubleRoom'
import VipRoom from './VipRoom'

export { Layout, Hotel, RoomListItem, Documentation, SingleRoom, DoubleRoom, VipRoom }



// WEBPACK FOOTER //
// ./src/features/Hotel/components/index.js